(function ($){
    let commentform= $('#commentform'),
        modal_information = $('#modal-information-simple'),
        modal_header = modal_information.find('.modal-content__header'),
        modal_body = modal_information.find('.modal-content__body'),
        popup = new bootstrap.Modal(modal_information);

    commentform.submit(function(){

        let formdata = commentform.serialize(),
            formurl = commentform.attr('action');

        //Post Form with data
        $.ajax({
            type: 'post',
            url: formurl,
            data: formdata,
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                modal_body.html('<p>Error</p>');
                popup.show();
            },
            success: function(data, textStatus){
                $('.feedback__form').slideUp(0);
                modal_header.html('<h2>Thanks for your review!</h2>');
                modal_body.html('<p>We love hearing from our community and truly take all feedback to heart, innovating designs based on invaluable insights from riders like you and your family all around the world.</p>');
                popup.show();
            }
        });
        return false;
    });
}(jQuery));
